import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import {shouldReloadCache} from "./cacheUtil";

export const NEXT_PERIOD_CACHE_KEY = 'nextPeriodCache';

const EIGHT_HOURS = 8;

export const loadNextPeriod = (breakCache = false) => {

    if (shouldReloadCache(NEXT_PERIOD_CACHE_KEY, EIGHT_HOURS) || breakCache) {
        console.log("=============> Refreshing getNextPeriod Cache");
        return makeApolloClientCall('{ periods(periodEndWeeksOnly:true excludeFuture:false){ endDate, isCurrentPeriod periodAbbreviation} }')
            .then((results) => {
                const periods = results.periods.sort((o1, o2) => o1.endDate.localeCompare(o2.endDate));
                const currentPeriodIndex = periods.findIndex(x => x.isCurrentPeriod);
                const nextPeriod = periods[currentPeriodIndex + 1];
                const date = new Date(nextPeriod.endDate);
                date.setDate(date.getDate() + 14)

                window.localStorage.setItem(NEXT_PERIOD_CACHE_KEY, JSON.stringify({
                    'nextPeriod': date,
                    'periodAbbreviation': nextPeriod.periodAbbreviation,
                    "cacheTime": Date.now(),
                }))
            });
    }
    return true;
}
